module.exports = __webpack_public_path__ + "img/0Q3A7268_L_WoodMatted.c5e5a3f8.jpg";